import React from "react";
import { injectIntl } from "react-intl";
import { SolutionStepBase } from "../../../components/single-registry/solutions/SolutionStep";
import { Box, Typography } from "@material-ui/core";
import { SolutionCardList } from "../../../components/single-registry/solutions/SolutionCardList";

const styles = {
  title: {
    fontWeight: 400,
    color: "#1E293B",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontSize: "18px",
    lineHeight: "25px",
  },
  subtitle: {
    fontWeight: 500,
    color: "#475569",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontSize: "14px",
  },
  boxContainer: { margin: "2.5rem 0" },
  boxTitles: { textAlign: "left", paddingBottom: "2rem" },
};

export class SolutionStepWidget extends SolutionStepBase {
  render() {
    const { intl, activeSolutions } = this.props;

    // Use props customizados ou fallback para mensagens default
    const displayTitle = this.getTitleI18n();
    // subtitle undefined = set default, subtitle null = does not show subtitle
    const displaySubtitle = this.getSubtitleI18n();

    const solutionsWithI18n = this.getSolutionsWithI18n(intl);

    return (
      <Box sx={styles.boxContainer}>
        <Box sx={styles.boxTitles}>
          <Typography style={styles.title}>{displayTitle}</Typography>
          {displaySubtitle && (
            <Typography style={styles.subtitle}>{displaySubtitle}</Typography>
          )}
        </Box>
        <SolutionCardList
          cards={solutionsWithI18n}
          solutionsSelected={this.props.solutionsSelected}
          solutionsCodesSelected={this.props.solutionsCodesSelected}
          getSolutionsCodes={this.props.getSolutionsCodes}
          onSolutionsCodesChanges={this.props.onSolutionsCodesChanges}
          onSolutionToggle={this.props.onSolutionToggle}
          activeSolutions={activeSolutions}
        />
      </Box>
    );
  }
}

export default injectIntl(SolutionStepWidget);
